import styled from 'styled-components';
import { SELECTORS } from '../../../constants/constants';

export const GiftIconContainer = styled.div`
    ${SELECTORS} & {
      width: 160px;
      height: 155px;
      position: relative;
      margin: auto;
      img{
        max-width: none;
      }
    }
`;

export const YellowIconImage = styled.div`
    ${SELECTORS} & {
        position: absolute;
        top: 80px;
        left: 70px;
        z-index: 2;   
    }
`;

export const GreenIconImage = styled.div`
    ${SELECTORS} & {
       position: absolute;
       top: 30px;
       left: 0;
       z-index: 1;
       
    }
`;

export const BlueIconImage = styled.div`
    ${SELECTORS} & {
       position: absolute;
       top: 0;
       left: 55px;
       z-index: 0;
    }
`;

